<template>
    <div class="text-center">
        <b-badge :variant="statusVariant" class="text-nowrap">
            <feather-icon :icon="statusIcon" size="12" class="mr-25" />
            <span class="align-middle">{{ statusText }}</span>
        </b-badge>
    </div>
</template>

<script>
import { BBadge } from "bootstrap-vue";

export default {
    name: "ShiftStatusBadge",
    components: {
        BBadge,
    },
    props: {
        row: {
            type: Object,
            required: true,
        },
    },
    computed: {
        isActive() {
            return this.row.ShiftEnd === null;
        },
        statusVariant() {
            return this.isActive ? "light-success" : "light-secondary";
        },
        statusText() {
            return this.isActive ? "Aktif Vardiya" : "Tamamlandı";
        },
        statusIcon() {
            return this.isActive ? "ActivityIcon" : "CheckCircleIcon";
        },
    },
};
</script>
